import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';

import * as _ from 'lodash';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { TcbService } from 'src/app/modules/admin/services/tcb.service';
import { CouponsService } from 'src/app/modules/retailer/services/coupons.service';

@Component({
  selector: 'app-show-tcb-coupon',
  templateUrl: './show-tcb-coupon.component.html',
  styleUrls: ['./show-tcb-coupon.component.scss']
})
export class ShowTcbCouponComponent implements OnInit {
  public loginData: any;

  @Input() couponData: any; // Coupon details (used for displayType = grid)
  @Input() couponListData: any; // Coupon list (used for displayType = list)
  @Input() displayType: any; // Display type (grid/list)
  @Output() addMetadata = new EventEmitter(); // Add metadata event

  public couponMetadatawModal: BsModalRef;
  public couponModalData: any;

  public categories: any = [];
  public categorySelectionSettings: IDropdownSettings;
  public categorySelectionDisabled: boolean;

  public manufacturers: any = [];
  public manufacturersLoading: boolean = false;

  public brands: any = [];
  public brandsLoading: boolean = false;

  public couponMetadataCategories: any = [];
  public couponMetadataManufacturer: any;
  public couponMetadataBrand: any;
  public couponMetadataTitle: string;
  public couponMetadataDescription: string;
  public couponMetadataImageFilesSelected: any = [];
  public couponImageFiles: File[] = [];
  public couponImageSelecting = false;
  public savingMetadata = false;

  public masterFormModal: BsModalRef;
  public masterFormModalData: any;

  constructor(
    private _utilService: UtilService,
    private _tcbService: TcbService,
    private _couponsService: CouponsService,
    private _modalService: BsModalService,
  ) { }

  ngOnInit(): void {
    // Set display type grid if not passed
    if(!this.displayType){
      this.displayType= 'grid';
    }

    this.getStorageData()
  }

  async getStorageData() {
    this.loginData = await this._utilService.getStorageData('A_LOGIN');

    // Category selection settings
    this.categorySelectionSettings = {
      singleSelection: false,
      idField: 'category_id',
      textField: 'category_name',
      selectAllText: 'Select All Categories',
      unSelectAllText: 'UnSelect All Categories',
      //itemsShowLimit: 3,
      allowSearchFilter: false,
      enableCheckAll: false
    };

    this.getCategories();
    this.getManufacturers();
  }

  public formatComa(products: string): string {
    return products.replace(/\,/g, ", ");
  }

  // Show coupon metadata modal
  async showCouponMetadataModal(coupon: any, template: TemplateRef<any>) {
    if (coupon.metadata_status == 1) {
      this._utilService.showToast('Metadata is already added for this coupon', '', 'warning', {});
    } else {
      // Reset data
      this.couponModalData = coupon;
      this.couponMetadataTitle = this.couponModalData.description;
      this.couponMetadataDescription = '';
      this.couponMetadataImageFilesSelected = [];
      this.couponImageFiles = [];
      this.couponImageSelecting = false;
      this.savingMetadata = false;

      this.couponMetadatawModal = this._modalService.show(template, {class: 'modal-lg'});
    }
  }

  // Hide coupon metadata modal
  hideCouponMetadataModal(): void {
    this.couponMetadatawModal.hide();
  }

  // Show master form modal
  async showMasterFormModal(mode: string, title: string, template: TemplateRef<any>) {
    // Reset data
    this.masterFormModalData = {
      mode: mode,
      title: title
    };

    this.masterFormModal = this._modalService.show(template, {class: 'modal-lg'});
  }

  // Hide master form modal
  hideMasterFormModal(): void {
    this.masterFormModal.hide();
  }

  // Master form actions
  masterFormActions(mode: string, event: any) {
    if (mode == 'category' && event.action == 'added') { // Reload category list
      this.getCategories();
    } else if (mode == 'manufacturer' && event.action == 'added') { // Reload manufacturer list
      this.getManufacturers();
    } else if (mode == 'brand' && event.action == 'added') { // Reload brand list
      this.getBrands();
    }

    this.hideMasterFormModal();
  }

  // Get categories
  getCategories() {
    this.categories = [];
    this.categorySelectionDisabled = true;

    this._couponsService.getCategories(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id).subscribe(async getCategoriesResponse => {
      this.categorySelectionDisabled = false;
      
      if (getCategoriesResponse.status === true) { // Success
        this.categories = getCategoriesResponse.categories;
      } else {
        this._utilService.showToast(getCategoriesResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getCouponTypes
      this.categorySelectionDisabled = false;
    });
  }

  // Get manufacturers
  getManufacturers() {
    this.manufacturers = [];
    this.manufacturersLoading = true;

    this._couponsService.getManufacturers(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, false).subscribe(async getManufacturersResponse => {
      this.manufacturersLoading = false;

      if (getManufacturersResponse.status === true) { // Success
        this.manufacturers = getManufacturersResponse.manufacturers;
      } else {
        this._utilService.showToast(getManufacturersResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getCouponTypes
      this.manufacturersLoading = false;
    });
  }

  // On Category select
  /*onCategorySelect(category: any) {
    this.couponMetadataCategories.push(category);
  }*/

  // On Category deselect
  onCategoryDeSelect(category: any) {
    this.couponMetadataCategories = _.filter(this.couponMetadataCategories, obj => obj.category_id != category.category_id);
  }

  // Manufacturer change
  onManufacturerChange(event: any) {
    this.getBrands();
  }

  // Get brands
  getBrands() {
    this.brands = [];
    this.brandsLoading = true;

    this._couponsService.getBrands(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, this.couponMetadataManufacturer.mfg_id).subscribe(async getBrandsResponse => {
      this.brandsLoading = false;

      if (getBrandsResponse.status === true) { // Success
        this.brands = getBrandsResponse.brands;
      } else {
        this._utilService.showToast(getBrandsResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getCouponTypes
      this.brandsLoading = false;
    });
  }

  // On image select
  onImageSelect(event) {
    // Remove files if exists
    this.onImageRemove(null);
    
    this.couponImageSelecting = true;
    for (let i=0; i<=event.addedFiles.length - 1; i++) {
      this._utilService.imageFiletoBase64(event.addedFiles[i], 50).then(fileContents => {
        let fileIndex = this.couponMetadataImageFilesSelected.length + 1;

        this.couponMetadataImageFilesSelected.push({
          id: fileIndex,
          file: event.addedFiles[i],
          file_base64: fileContents,
          file_s3: null
        }); // Add image to uploaded list
        this.couponImageSelecting = false;
      }, error => {
        this.couponImageSelecting = false;
        this._utilService.showToast(error, '', 'error', {});
      });
    }
  }

  // On image remove
  onImageRemove(event) {
    this.couponMetadataImageFilesSelected = [];
  }

  // On save coupon metadata
  async onSaveMetaData() {
    // Validations
    if(this.couponMetadataCategories.length == 0) { // Category
      this._utilService.showToast('Please select coupon category', '', 'warning', {});
      return false;
    }

    if(!this.couponMetadataManufacturer) { // Manufacturer
      this._utilService.showToast('Please select coupon manufacturer', '', 'warning', {});
      return false;
    }

    if(!this.couponMetadataBrand) { // Brand
      this._utilService.showToast('Please select coupon brand', '', 'warning', {});
      return false;
    }

    if(!this.couponMetadataTitle) { // Title
      this._utilService.showToast('Please enter coupon title', '', 'warning', {});
      return false;
    }

    if(!this.couponMetadataDescription) { // Description
      this._utilService.showToast('Please enter coupon description', '', 'warning', {});
      return false;
    }

    if(this.couponMetadataImageFilesSelected.length == 0) { // Image
      this._utilService.showToast('Please select coupon image file', '', 'warning', {});
      return false;
    } 
    
    // Upload images to S3
    this.savingMetadata = true;

    //let imageFolder: string = environment.s3_folder_tcb_coupons + '/';
    let imageFolder: string = environment.cloud_storage_folder_prefix + '/' + environment.cloud_storage_folder_tcb_coupons;
    for(let i=0; i<=this.couponMetadataImageFilesSelected.length - 1; i++) {
      if (this.couponMetadataImageFilesSelected[i].file) { // Upload only new files
        /*let imageUploadResponse: any = await this._utilService.s3Base64Upload(this.couponMetadataImageFilesSelected[i].file, this.couponMetadataImageFilesSelected[i].file_base64, environment.s3_bucket, imageFolder);

        if(imageUploadResponse.status == true){ // Upload success
          this.couponMetadataImageFilesSelected[i].file_s3 = imageUploadResponse.location;
          
          let addTcbMetadataBody = {
            admin_tcb_coupon_master_id: this.couponModalData.admin_tcb_coupon_master_id,
            base_gs1: this.couponModalData.base_gs1,
            metadata_status: '1', 
            categories: this.couponMetadataCategories,
            mfg_id: this.couponMetadataManufacturer.mfg_id,
            brand_id: this.couponMetadataBrand.brand_id,
            metadata_title: this.couponMetadataTitle.replace("'","''''"),
            metadata_terms: this.couponMetadataDescription.replace("'","''''"),
            metadata_mobile_image_url: imageUploadResponse.location
          };
          
          this._tcbService.addTcbMetadata(this.loginData.token, addTcbMetadataBody).subscribe(async addTcbMetadataResponse => {
            this.savingMetadata = false;
    
            if (addTcbMetadataResponse.status === true) { // Success
              this._utilService.showToast('Coupon metadata added succesfully for base_gs1 ' + this.couponModalData.base_gs1, '', 'success', {});
              this.hideCouponMetadataModal();

              this.addMetadata.emit({ action: 'metadata-added', base_gs1: this.couponModalData.base_gs1 });
            } else {
              this._utilService.showToast(addTcbMetadataResponse.message, '', 'error', {});
            }
          }, error => { // Error from addTcbMetadata
            this.savingMetadata = false;
            this._utilService.showToast(environment.apiErrorMessage, '', 'error', {});
          });
        } else { // Upload Error
          this._utilService.showToast('Error while uploading image', '', 'error', {});
          this.savingMetadata = false;
          break;
        }*/

        // Upload file to cloud storage
        let uploadFileBody: any = {
          bucket: environment.cloud_storage_bucket,
          folder: imageFolder,
          fileType: this.couponMetadataImageFilesSelected[i].file.type,
          base64Data: this.couponMetadataImageFilesSelected[i].file_base64
        }
        
        this._utilService.uploadFile(this.loginData.token, uploadFileBody).subscribe(async uploadFileResponse => {
          if (uploadFileResponse.status === true) { // Success
            this.couponMetadataImageFilesSelected[i].file_s3 = uploadFileResponse.file_name;
          
            let addTcbMetadataBody = {
              admin_tcb_coupon_master_id: this.couponModalData.admin_tcb_coupon_master_id,
              base_gs1: this.couponModalData.base_gs1,
              metadata_status: '1', 
              categories: this.couponMetadataCategories,
              mfg_id: this.couponMetadataManufacturer.mfg_id,
              brand_id: this.couponMetadataBrand.brand_id,
              metadata_title: this.couponMetadataTitle.replace("'","''''"),
              metadata_terms: this.couponMetadataDescription.replace("'","''''"),
              metadata_mobile_image_url: uploadFileResponse.file_name
            };
            
            this._tcbService.addTcbMetadata(this.loginData.token, addTcbMetadataBody).subscribe(async addTcbMetadataResponse => {
              this.savingMetadata = false;
      
              if (addTcbMetadataResponse.status === true) { // Success
                this._utilService.showToast('Coupon metadata added succesfully for base_gs1 ' + this.couponModalData.base_gs1, '', 'success', {});
                this.hideCouponMetadataModal();

                this.addMetadata.emit({ action: 'metadata-added', base_gs1: this.couponModalData.base_gs1 });
              } else {
                this._utilService.showToast(addTcbMetadataResponse.message, '', 'error', {});
              }
            }, error => { // Error from addTcbMetadata
              this.savingMetadata = false;
              this._utilService.showToast(environment.apiErrorMessage, '', 'error', {});
            });
          } else {
            this._utilService.showToast('Error while uploading image', '', 'error', {});
            this.savingMetadata = false;
          }
        }, error => { // Error from createCircular
          this.savingMetadata = false;
        });
      }
    }
  }

}
